module.exports = {
  // 韩语
  language: "한국인",

  //确认支付按钮
  components_confirmPay_btn: {
    notYet: "준비중",
    waitingTips: "지불을 기다리는 중",
  },

  //买币阿根廷支付
  ArgentinaPay: {
    BankName: "은행명",
    ChooseBank: "은행 선택",
    selectcard: "은행을 선택하세요",
    BankAccount: "은행 계좌",
    cardnumber: "올바른 카드 번호를 입력하세요",
    Bankcode: "은행 코드",
    correctcode: "올바른 코드를 입력하세요",
    ID: "아이디",
    SelectBank: "은행 선택",
    phone: "휴대폰 번호",
    phoneTips: "휴대폰 번호가 올바르지 않습니다!",
    paymentResultError:
      "은행 계좌 정보가 올바르지 않습니다. 확인하시고 다시 구매해주세요.",
    Choose: "계좌 유형 선택",
    chequing: "사용 계좌",
    Saving: "저축 계좌",
    Amount: "금액:",
    AccountNumber: "계좌 번호",
    BankCode: "은행 코드",
    fullNameTips: "잘못된 전체 이름",
    idTips: "잘못된 ID 번호",
  },

  //菜单
  menu: {
    home: "홈",
    menu: "메뉴",
    transactions: "거래",
    language: "언어",
    privacy: "개인정보 보호",
    logOut: "로그아웃",
    service: "서비스 약관",
    RouterMenu_experience: "확인하려면 로그인하세요",
    login_Youlogged: "이미 로그인했습니다",
    RouterMenu_Welcome: "Alchemy Pay에 오신 것을 환영합니다!",
    RouterMenu_history: "내역이 없습니다",
    loginOut_Dismiss: "로그아웃",
    loginOut_title: "로그아웃 하시겠습니까?",
  },

  //导航文案
  navTabTitle: {
    Completepayment: "결제 완료하기",
  },

  //---------------------------- 表单信息 ----------------------------
  formInfo: {
    //vnd 选择bank code
    vnd_bankCode_placeholder: "은행 코드 선택",
    //新增
    fullName_placeholder: "성함을 입력하세요.",
    phone_title: "휴대폰 번호를 입력하세요.",
    id_title: "아이디 번호를 입력하세요.",
    id_placeholder1: "다음을 입력하세요.",
    id_placeholder2: "숫자 아이디 번호",
    bankAccount_placeholder: "계좌 유형 선택",
    accountNumber_placeholder: "22자리 아이디 번호 입력",
    bankCode_placeholder: "3자리 아이디 번호 입력",
    select_id_placeholder: "ID 유형 선택",
  },

  //vnd新增文案 越南支付文案
  vndChildren: {
    amount: "금액",
    oneTitle: `은행 앱에서 QR코드를 스캔하거나 수령인 아이디를 직접 입력하세요`,
    twoTitle: " 메시지 상자에 거래 내용을 입력하세요",
    threeTitle: "송금하기",
    Accountname: "계좌명",
    AccountID: "계좌 아이디",
    Transfercontent: "거래 내용",
  },

  // TRY银行转账表单信息
  TRY_form: {
    // TRY银行转账
    nationality_title: "국적을 입력하다",
    authCardNo_title: "주민등록번호 입력",
    firstName_title: "이름 입력",
    lastName_title: "성 입력",
    address_title: "주소 입력",
    birthday_title: "생일 입력",
    authCardNo_tips: "잘못된 주민등록번호",
    firstName_Tips: "잘못된 이름",
    lastName_tips: "성이 잘못되었습니다.",
    address_tips: "잘못된 주소",
    birthday_tips: "잘못된 생일",
    address_Placeholder: "주민등록증의 주소와 동일",
    ID_CARD: "신분증",
    DRIVER_LICENSE: "운전면허",
    PASSPORT: "여권",
  },

  // KRW银行转账表单信息
  KRW_form: {
    // TRY银行转账
    nationality_title: "국적을 입력하다",
    authCardNo_title: "주민등록번호 입력",
    firstName_title: "이름 입력",
    lastName_title: "성 입력",
    address_title: "주소 입력",
    birthday_title: "생일 입력 (일/월/년)",
    authCardNo_tips: "잘못된 주민등록번호",
    firstName_Tips: "잘못된 이름",
    lastName_tips: "성이 잘못되었습니다.",
    address_tips: "잘못된 주소",
    birthday_tips: "잘못된 생일",
    address_Placeholder: "주민등록증의 주소와 동일",
    RESIDENT_REGISTRATION_NUMBER: "신분증",
    DRIVER_LICENSE: "운전면허",
    PASSPORT_NUMBER: "여권",
    ALIEN_REGISTRATION_NUMBER: "거주증",
    DOMESTIC_RESIDENCE_REPORT_NUMBER: "주소 등록증",
  },

  //---------------------------- 用户支付信息组件 ----------------------------
  TraderInformation: {
    title: "상인 정보",
  },

  //---------------------------- 银行转账收银台 ----------------------------
  cashierDesk_bankTransfer: {
    tiemOut: "에서 주문이 취소됩니다 {0} {1}",
    PleasePay: "지불해 주십시오",
    title1: "은행 신청서를 엽니다.이 참조 번호를 입력합니다. ",
    title2: "계정 등록 정보 입력",
    CLABEinterbancaria: "CLABE 은행간:",
    Destinationbank: "목적지 은행:",
    Beneficiary: "수익자:",
    Payamount: "지급 금액:",
    title3:
      "만약 당신의 지불이 장기간 완성되지 않으면, 우리는 당신이 지불 서류를 우리의 고객센터에 업로드하는 것을 건의합니다.이것은 우리가 당신의 지불에 대한 확인을 가속화할 것입니다.",
  },

  //---------------------------- 支付方式信息组件 ----------------------------
  PayMethodInfo_components: {
    title: "주문 요약",
    title2: "선택한 결제 방법",
  },

  //---------------------------- 扫码QR Code组件 ----------------------------
  QrCode_components: {
    title1: "결제",
    title2: "결제를 완료하려면.",
    title3: "결제 앱을 열고 아래 QR 코드를 스캔하여 결제를 완료하세요.",
    copy: "복사",
  },

  //---------------------------- 钱包地址和网络信息组件 ----------------------------
  WalletAddress_components: {
    title1: "귀하",
    title2: "지갑",
  },

  //菲律宾页面
  phpPayment: {
    PaymentGuide: "결제 가이드",
    BillNumber: "디지털 송금 번호",
    PAYSO1: 'Gcash 지갑을 입력하고 "Bills"을 클릭한 뒤 요금 결제를 선택합니다',
    PAYSO2: '"PAYSO"를 검색해 선택합니다',
    PAYSO3: "정보를 입력하고 [NEXT]를 클릭합니다",
    Incorrect:
      "송금하시는 금액이 정확한지 확인하세요. 잘못된 정보 또는 금액은 주문 실패 또는 자금 손실을 초래합니다.",
  },

  //选择支付方式页
  buyPayWay: {
    qrCode: "QR 코드",
    ArgentinaPay: "은행 송금",
    pix: "PIX",
    recentlyUsed: "최근 사용됨",
    paymentMethod: "결제 수단",
    rampFee: "처리 수수료",
    card: "카드",
    creditCard: "신용 카드",
    bankTransfer: "프롬프트 페이",
    bancoTransfer: "Banco 결제",
    opm: "OPM",
    virtualAccount: "가상 계좌",
    eWallet: "E-지갑",
    binancePay: "바이낸스 페이",
    promptPay: "프롬프트 페이",
    addCardTitle: "새 카드 추가",
    useCardTitle: "새 카드 사용",
    edit: "수정",
    cancel: "취소",
    support: "지원",
    cardLimitTips: "카드 한도 도달(6개)",
    kaKaoPay: "카카오 페이",
    GCash: "은행 송금",
    touchNGo: "터치앤고",
    payNow: "지금 결제",
    proceed: "진행",
    deleteTips: "성공적으로 삭제되었습니다",
    Unavaible: "없는",
    limit: "한계",
    Philippines: "송금",
  },

  //买币信用卡表单组件
  components_buyForm: {
    formTitle: "카드 정보를 입력하세요.",
    firstName: "이름",
    lastName: "성",
    nameTips: "이름이 올바르지 않습니다!",
    cardNumber: "카드 번호",
    cardNumTips: "올바른 카드 번호를 입력하세요.",
    expirationDate: "만기일",
    dataTips: "만기일이 올바르지 않습니다",
    cvv: "CVV",
    cvvTips: "올바른 CVV를 입력하세요.",
  },

  //国际卡确定订单页
  creditCard: {
    payingWith: "다음으로 결제",
    card: "카드",
    cvv: "CVV",
  },

  //买币确定订单页 - 巴西支付
  configPay_brl: {
    phoneNumber: "휴대폰 번호",
    fullName: "성함",
    formTitle: "세부 정보를 입력하세요.",
    code_tips: "PIX를 통해 QR 코드를 스캔하여 결제를 완료하세요.",
    name_tips: "성함이 올바르지 않습니다!",
    id_tips: "아이디가 올바르지 않습니다!",
    number_tips: "휴대폰 번호가 올바르지 않습니다!",
    selectCountry: "국가 선택",
  },

  //确认订单页 - 墨西哥支付
  opmPayment: {
    banco: "Banco",
  },

  //弹出框文案
  components_payConfig: {
    title_THB: "결제 진행중",
    button_THB: "주문 확인",
    button_timeOut: "홈페이지로",
    button_timeOut1: "홈으로",
    double: "이중 결제를 하지 마세요.",
    completed: "송금이 완료되었는지 확인해주세요.",
    timeorder: "주문이 만료되었습니다.",
    checkout: "결제 카운터를 떠나시겠습니까?",
    buttonLeave: "주문 종료",
  },

  //买币历史订单页+买币订单详情页
  buyHistory: {
    buyPrice: " 가격 ",
    buyTotal: "총계 ",
    buyOrderID: "주문 아이디",
    buyOrdeTime: "주문 시간",
    buyPaymentTime: "결제 시간",
    buyPayerAccount: "결제인 계좌",
    buyCompleted: "완료됨",
    buyFailed: "실패",
    buyClosed: "종료됨",
    history_noListText: "결제 내역 없음",
    history_noListButton: "지금 NFT 구매",
    history_noMore: "없음",
  },

  //登陆页
  loginPage: {
    enterEmail: "이메일 주소가 무엇인가요?",
    enterEmail1: "귀하의 이메일 주소인가요?",
    emailanother: "다른 이메일 주소로 로그인",
    emailNotyou: "귀하가 아니신가요?",
    codeTitle1: "방금 받으신 로그인 코드를 입력하세요.",
  },
  nav: {
    //买币确认订单文案提示
    buyConfigPaytitle: "계속할 시 귀하는 다음에 동의합니다.",
    /**
     * 按钮文案
     */
    Continue: "계속",
    Confirm: "확인",
    ConfirmPayment: "결제 확인",
    queryOderState: "결제를 완료했습니다.",
    Proceed: "진행",
    //风险账户文案
    accountTraded: "이 계정은 위험에 처해 있으며 지금은 거래할 수 없습니다.",

    /**
     * 路由
     */
    routerName_Transactions: "주문 내역",
    routerName_paymentMethod: "결제 방법을 선택하세요.",
    routerName_creditCardConfig: "결제 확인",
    routerName_buyPayment: "결제",
    routerName_buyOtherWayPay: "결제를 확인하세요.",
    routerName_paymentResult: "결제 결과",
    routerName_kycOnfido: "신원 증명 & 셀프카메라",
    routerName_kycSumsub: "신원 증명 & 셀프카메라 & POA",

    /**
     * 登陆
     */
    login: "로그인",
    login_required: "형식 오류.",
    login_necessary: "필요한",

    loginTitle1: "Alchemy Pay로 결제",
    loginTitle2:
      "수백 개의 크립토 앱에서 결제할 수 있는 가장 빠르고 안전한 방법입니다.",

    codeTitle2: "받지 못했습니까? ",
    codeTitle3: "새로운 인증 코드를 보냈습니다. ",
    codeSecond: "초",
    code_text: "다음 Alchemy pay 사항을 읽고 동의합니다. ",
    code_and: "그리고",
    code_name2: "개인정보 보호 정책",

    /**
     * 首页
     */
    copyTips: "복사 성공",

    //买币 - 确认订单 - 国际卡
    buy_configPay_title1: "다음으로 결제",

    //买币 - 确认订单 - 印尼支付
    buy_configPayIDR_va_title: "은행",
    buy_configPayIDR_va_codeTitle: "결제 코드",
    buy_configPayIDR_codeTips: "결제 완료를 위해 QR 코드를 스캔하세요.",
    buy_configPayIDR_ovo_phoneTips: "결제 완료를 위해 OVO 앱을 여세요.",

    // 后增
    search_components_placeHolder: "여기서 검색… ",
    buy_configPayIDR_ovo_title: "OVO 휴대폰",
    login_getCode: "코드 다시 보내기",
    login_VerifyCode: "인증 코드 6자리를 입력하세요.",
    login_Agreement: "이용약관에 체크해주세요.",
  },

  //确认订单通用
  confirmOrder: {
    pleasePay: "결제해주세요.",
  },

  //首页
  homePage: {
    purchaseNFT: "NFT 구매",
    item: "아이템",
    quantity: "수량",
    youPay: "결제",
    proceedBuy: "구매 진행",
    selectCurrency: "통화 선택",
    tiemErrToast: "주문 시간이 초과되어 다음 단계로 진행할 수 없습니다.",
    USDTips: "현재 USD를 지원하지 않습니다. 다른 화폐 통화를 선택하세요.",
  },

  //交易历史
  transactionHistory: {
    buy: "구매",
    item: "아이템",
    price: "가격",
    quantity: "수량",
    total: "총계",
    uniqueId: "고유 아이디",
    loading: "로드 중",
    loadingFailed: "로드 실패",
  },
  //等待组件
  buypayWait: {
    Processing: "진행중",
    progress: "주문 진행중",
    purchase: "이 아이템을 구입하려면",
    transaction: "최종 거래를 완료하세요!",
  },
  //结果页
  payResult: {
    buttonText: "다음으로 돌아가기 ",
    goHistory: "주문 내역 보기",
    closed1: "이 주문은 만료되었습니다.",
    closed2: "주문을 다시 진행하세요.",
    failed1: "결제 실패!",
    failed2: "정보가 잘못되어 은행에서 거부되었습니다.",
    failed1010: "결제 금액이 현재 결제 수단 한도와 일치하지 않습니다.",
    success1: "감사합니다!",
    success2: "구매에 성공했습니다.",
    success3: "주문 내역을 귀하의 이메일로 전송했습니다.",
    waitTips: "결제 대기 중",
  },

  //费用信息组件
  buyFee_components: {
    codeSecond: "s",
    title: "NFT 구매",
    rampFee: "처리 수수료",
    rampFeeTips: "최저",
    networkFee: "네트워크 수수료",
    tips: "이는 결제 처리와 관련된 비용을 충당하기 위해 AlchemyPay에서 청구합니다. 나중에 선택하시는 결제 방법에 따라 변동될 수 있습니다.",
  },

  // kyc_onfido
  kycAlert: {
    waiting_msg: "귀하의 신원 확인 & 셀프카메라가 검토 중입니다:",
    success_msg: "신원 증명 성공",
    failure_msg: "관련 문서 다시 제출",
  },
  kycStatus: {
    account: "계정:",
    login_time: "마지막 로그인 시간:",
    verify_succeeded: {
      tips: "신원 증명 성공",
      content:
        "축하해요! 모든 제출 문서가 검증 절차를 통과했습니다. 일일 거래 한도가 {0}으로 증가했습니다.",
      process: "절차",
    },
    verify_exception: {
      tips: "관련 문서 다시 제출",
      update_document: "문서 업데이트",
    },
    verify_failed: {
      tips: "신원 증명 거절됨",
    },
    verify_waiting: {
      received_documents: "귀하의 KYC 문서를 받았습니다.",
      notify_you:
        "이메일을 통해 확인 결과를 알려드리겠습니다. 보통 5~10분 정도 소요됩니다. 종종 수동 재감사가 수행될 수 있습니다. 수동 검토는 24시간 이내에 완료됩니다.",
      leave: "지금 떠나기",
      under_review: "검토중...",
      estimated_time: "예상 대기 시간:",
      waiting_time: "대기중입니다:",
      reviewed_now: "현재 제출하신 문서가 검토중에 있습니다.",
    },
  },

  //kyc验证页面
  kycVerificationFonts: {
    kycminutestitle:
      "귀하의 신원을 인증하시기 바랍니다. 보통 2분 정도 걸립니다.",
    kycPrepareyour: "신분증 준비하기",
    kycminutesdocument: "문서와 함께 셀카를 준비하세요.",
    kycButtonminutes: "인증 시작하기",
    kyccompleted1: "축하합니다! ",
    kyccompleted2: "인증이 완료되었습니다.",
    kycButtoncompleted: "결제 계속하기",
    kycPayLimitUpTips: "결제 한도:",
    kycError: "인증에 실패했습니다.",
    kycRiskAccount: "계정이 위험에 처해 현재 거래할 수 없습니다.",
    kycButtonError: "홈페이지로",
    kycButtonTryAgain: "다시 시도하기",

    kyc2_startTitle: "주소 자료를 제공해주세요.",
    kycErrorTips: "귀하의 주소는 진실하고 검증 가능해야 합니다.",
    kycErrorTryAgain_title: "인증에 실패했습니다.",
    kycErrorTryAgain_tipsTitle: "다음을 확인해주세요.",
    kycErrorTryAgain_tips1: "본인 신분증을 제출하셨습니다.",
    kycErrorTryAgain_tips2:
      "신분증의 이름이 결제 카드 소지자의 이름과 동일합니다.",
    kycErrorTryAgain_tips3:
      "YKYC 인증을 위해 여러 신분증 문서를 사용하지 않았습니다.",
  },
};
